























































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import Role from '@/models/role';
import User from '@/models/user';

@Component
export default class AssignRoleModal extends Vue {
  @Prop() role: Role;
  @Prop() users: User[];
  @Prop() assignRole: any;
  Role: Role;
  userList = '';
  assignedUsers: User[];
  normalUsers: User[];
  selectedUser = -1;

  @Watch('role', {immediate: true})
  roleChanged(newValue: any, oldValue: any) {
    if (!newValue) return;
    this.Role = newValue;
  }

  @Watch('users', {immediate: true})
  usersChanged(newValue: any[], oldValue: any[]) {
    if (!newValue.length) return;
    this.assignedUsers = newValue.filter((user) => user.groupId === this.Role.groupId);
    this.userList = this.assignedUsers.map((user) => user.name).join(', ');

    this.normalUsers = newValue.filter((user) => user.groupId !== this.Role.groupId);
  }

  onClick(e) {
    if (this.assignRole) {
      const internalUser = this.users.find((usr) => usr.id === this.selectedUser);
      this.assignRole(internalUser.internalId, this.Role.groupId);
    }
    this.resetUser();
  }
  resetUser() {
    this.selectedUser = -1;
  }
}
